import PropTypes from "prop-types";
import { RadioButton } from "primereact/radiobutton";
import { classNames } from "primereact/utils";

export default function FormRadio(props) {
  const {
    className = "",
    isControl = true,
    setting: { Controller, control, trigger, isSubmitted, isEdit = true } = {},
    data: {
      name,
      label,
      value,
      elValue,
      elChange,
      disabled = false,
      cancel = false,
    },
  } = props;

  const onChange = (e, field) => {
    let value = e.value,
      checked = e.target.checked;
    if (cancel && !checked) {
      value = null;
    }

    if (isControl) {
      field.onChange(value);

      if (isSubmitted) {
        trigger();
      } else {
        trigger(name);
      }
    } else {
      elChange({ name, value, options: props.data });
    }
  };

  const renderElement = ({ field, fieldState } = {}) => {
    return (
      <div
        className={classNames(
          "relative flex align-items-center",
          {
            "min-w-220 ml-1 mr-3 my-2": !className,
          },
          className
        )}
      >
        <RadioButton
          inputId={`${name}_${value}`}
          className={classNames({
            "p-invalid": isControl && fieldState.invalid,
          })}
          name={name}
          value={value}
          checked={value === (isControl ? field.value : elValue)}
          onChange={(e) => onChange(e, field)}
          disabled={!isEdit || disabled}
        />
        {label && (
          <label htmlFor={`${name}_${value}`} className="ml-2">
            {label}
          </label>
        )}
      </div>
    );
  };

  return (
    <>
      {isControl ? (
        <Controller
          name={name}
          control={control}
          render={({ field, fieldState }) =>
            renderElement({ field, fieldState })
          }
        />
      ) : (
        renderElement()
      )}
    </>
  );
}

FormRadio.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape({
    cancel: PropTypes.bool,
    disabled: PropTypes.bool,
    elChange: PropTypes.func,
    elValue: PropTypes.any,
    label: PropTypes.node,
    name: PropTypes.string,
    value: PropTypes.any,
  }).isRequired,
  isControl: PropTypes.bool,
  setting: PropTypes.shape({
    control: PropTypes.object,
    Controller: PropTypes.elementType,
    isEdit: PropTypes.bool,
    isSubmitted: PropTypes.bool,
    trigger: PropTypes.func,
  }),
};
